import {Component, Input, OnInit} from '@angular/core';
import {BaseDialog} from '../base-dialog';
import {Product} from '../../../class/central/product';
import {Router} from '@angular/router';
import {NbDialogRef} from '@nebular/theme';

@Component({
  selector: 'app-products-dialog',
  templateUrl: './products-dialog.component.html',
  styleUrls: ['./products-dialog.component.css']
})
export class ProductsDialogComponent extends BaseDialog<Product> implements OnInit {

  @Input()
  products: Product[];

  constructor(dialogRef: NbDialogRef<Product>, route: Router) {
    super(dialogRef, route);
  }

  ngOnInit() {
  }
}
